import { type StateType } from '../../states';
import { type FlashMessages } from '../../states/flashmessages';
import { type FlashMessageState } from '../../states/flashmessages';
import { type FlashMessageScope, type FlashMessageSeverity, type FlashMessageType } from '../../types/flashmessage';
import { type Selector } from '../../types/selectors';

export const selectFlashMessages: Selector<FlashMessages> = (state: StateType) => state.flashmessages;

//#region state.flashmessages
type FlashMessagesSelectorProps = {
  flashMessageId?: string;
  id?: string;
};

export const selectFlashMessagesEntity: Selector<FlashMessageState | undefined> = (
  state: StateType,
  props: FlashMessagesSelectorProps = {},
) => {
  const flashMessages = selectFlashMessages(state);
  const { flashMessageId, id: idFromProps } = props;
  const id = flashMessageId ?? idFromProps;

  if (id) {
    return flashMessages[id];
  }
};
//#endregion

//#region state.flashmessages[id]
export const selectFlashMessagesEntityId: Selector<string | undefined> = (
  state: StateType,
  props: FlashMessagesSelectorProps = {},
) => selectFlashMessagesEntity(state, props)?.id;

export const selectFlashMessagesEntityScope: Selector<FlashMessageScope | undefined> = (
  state: StateType,
  props: FlashMessagesSelectorProps = {},
) => selectFlashMessagesEntity(state, props)?.scope;

export const selectFlashMessagesEntitySeverity: Selector<FlashMessageSeverity | undefined> = (
  state: StateType,
  props: FlashMessagesSelectorProps = {},
) => selectFlashMessagesEntity(state, props)?.severity;

export const selectFlashMessagesEntityMessage: Selector<string | undefined> = (
  state: StateType,
  props: FlashMessagesSelectorProps = {},
) => selectFlashMessagesEntity(state, props)?.message;

export const selectFlashMessagesEntityType: Selector<FlashMessageType | undefined> = (
  state: StateType,
  props: FlashMessagesSelectorProps = {},
) => selectFlashMessagesEntity(state, props)?.type;
//#endregion
